<template>
    <div>
        <h6 class="title-section">{{$t('ClassRequest.sub-titulo-tab-4')}}</h6>
           <b-tabs class="sm">
			<b-tab :active="TabClassRequest" @click="changeTab(0)">
				<template #title>
					{{$t('student.tab-1')}} 
				</template>
            <div>
                <b-form inline style="margin-bottom: 18px;">
                    <b-form-group class="mr-2 w-100" :label="$t('class-teacher.student')" style="max-width: 24%;">
                        <v-autocomplete class="w-100" :items="items" v-model="item" :min-len="0" :get-label="getLabel" :component-item='template' @update-items="updateItems" :auto-select-one-item="false">
                        </v-autocomplete>
                    </b-form-group>
                    <b-form-group style="width: 24%;" class="mr-2" :label="$t('class-teacher.report-1')">
                        <CustomSelect
                            @input="idValueSelectEventOptionsReport"
                            :options="optionsReport"
                            value="id"
                            label="descripcion" 
                            :default="$t('filter.text')"
                            @change="getListClassTeacher()"
                        />
                            <!-- <b-form-select class="w-100"
                            v-model="selectedReport" 
                            :options="optionsReport" 
                            @change="getListClassTeacher()"
                            value-field="id"  
                            text-field="descripcion">
                                <template #first><b-form-select-option :value="null">Todos</b-form-select-option> </template>
                            </b-form-select> -->
                    </b-form-group >
                    <b-form-group class=" mb-0 mt-auto pb-1" id="group-radio-student" style="width: 18%;max-width: 180px;">
                        <b-form-radio class="m-auto" v-model="typeStudent" name="CurrentStudent" :value="true" @change="getListClassTeacher()" >{{$t('teacher-student.CurrentStudent')}}</b-form-radio>
                    </b-form-group>
                    <b-form-group class=" mb-0 mt-auto pb-1" id="group-radio-student" style="width: 19%;max-width: 180px;">
                        <b-form-radio class="m-auto" v-model="typeStudent" name="PreviousStudent" :value="false" @change="getListClassTeacher()" >{{$t('teacher-student.PreviousStudent')}}</b-form-radio>
                    </b-form-group>
                </b-form>
            </div>

            <b-table responsive  hover :items="itemsTableIndividual"  :busy="isBusy"  :fields="fields" :show-empty="true"
                    id="table-individual-my-student"  :tbody-transition-props="transProps"  primary-key="date" style="white-space: pre-line;"
                    :empty-text="$t('reusables.empty-text')">
                <template #table-busy>
                    <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong> {{$t('ClassRequest.Loading')}}...</strong>
                    </div>
                </template>
                <template #cell(student)="data">
                    <span style="cursor:pointer"  @click="getCoursesHistory(data.item,data.item)">{{data.item.student}}</span>
                     
                </template>
                <template #cell(schedule)="data">
                    <div class="table-icon" v-if="typeStudent">
                        <span @click="getListScheduleClass(data.item.groupId,data.item.groupScheduleStudentId)">
                                <img src="@/assets/icons/icon-calendar.svg"   class="svg">
                        </span>
                    </div>
                    <div class="table-icon" v-else>
                            <span>-</span>
                    </div>
                </template>
                <template #cell(classReport)="data">  
                    <div class="table-icon" v-if="data.value>=0" @click="getClassReport(data.item)">
                        <img src="@/assets/icons/icon-statistical-result.svg" class="svg">
                        <span class="dot" v-if="data.value>0" >{{data.value}}</span> 
                    </div>
                    <div class="table-icon" v-else> 
                            <span>-</span>
                    </div>
                </template>
                  
                
                <template #cell(assignments)="data">
                    <div class="table-icon" v-if="data.value>=0" @click="goEvaluationReportsSimple(1,data.item)">
                        <!-- <span class="material-icons-outlined icon-student" @click="getDetail(data.item.id,data.item)">question_answer</span> -->
                        <img src="@/assets/icons/icon-valid-doc.svg"  class="svg">
                        <span class="dot" v-if="data.value>0">{{data.value}}</span>
                    </div>
                    <div class="table-icon" v-else>
                            <span>-</span>
                    </div>
                
                </template>
                <template #cell(report)="data">
                        <div class="table-icon" v-if="data.value>=0" @click="goEvaluationReportsSimple(0,data.item)">
                        <!-- <span class="material-icons-outlined icon-student" @click="getDetail(data.item.id,data.item)">question_answer</span> -->
                        <img src="@/assets/icons/icon-result-note.svg" class="svg">
                        <span class="dot" v-if="data.value>0">{{data.value}}</span>
                    </div>
                    <div class="table-icon" v-else>
                            <span>-</span>
                    </div>
                    
                </template>
                <template #cell(chat)="data">
                    <div class="table-icon" v-if="data.value>=0" @click="redirectChat(data.item.groupId)">
                        <!-- <span class="material-icons-outlined icon-student" @click="getDetail(data.item.id,data.item)">question_answer</span> -->
                        <img src="@/assets/icons/icon-comments.svg" class="svg">
                        <span class="dot" v-if="data.value>0">{{data.value}}</span>
                    </div>
                    <div class="table-icon" v-else>
                            <span>-</span>
                    </div>
                
                </template>
                
            </b-table>
            <div class="overflow-auto content-pagination">
                <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                aria-controls="table-individual-my-student"
                ></b-pagination>
                {{currentPage}}-{{perPage}} / {{totalRows}}  {{$t('ClassRequest.text.3')}}
            </div>

			</b-tab>
			<b-tab :active="!TabClassRequest" @click="changeTab(1)">
				<template #title>
					Groups
				</template>
                <div>
                <b-form inline style="margin-bottom: 18px;flex-wrap: initial;">
                    <b-form-group class="mr-2" :label="$t('class-teacher.group')" style="max-width: 200px;width: 15vw;">
                        <v-autocomplete class="w-100" :items="itemsGroup" v-model="itemGroup" :min-len="0" :get-label="getLabelGroup" :component-item='templateGroup' @update-items="updateItemsGroup" :auto-select-one-item="false">
                    </v-autocomplete>
                    </b-form-group>
                    <b-form-group  style="max-width: 200px;width: 15vw;" class="mr-2" :label="$t('class-teacher.student')">
                        <v-autocomplete class="w-100" :items="itemsIndividual" v-model="itemIndividual" :min-len="0" :get-label="getLabelIndividual" :component-item='templateIndividual' @update-items="updateItemsIndividual" :auto-select-one-item="false">
                        </v-autocomplete>
                    </b-form-group>	
                    <b-form-group style="max-width: 300px;width: 15vw;" label="Student Reports">
                        <CustomSelect
                            @input="idValueSelectEventGroupStudent"
                            :options="optionsReport"
                            value="id"
                            label="descripcion" 
                            :default="$t('filter.text')"
                            @change="getListGroupClassTeacher()"
                        />
                        <!-- <b-form-select style="width:100%;"
                        v-model="selectedReportGroup" 
                        :options="optionsReport" 
                         @change="getListGroupClassTeacher()"
                        value-field="id"  
                        text-field="descripcion">
                            <template #first><b-form-select-option :value="null">Todos</b-form-select-option> </template>
                        </b-form-select> -->
                    </b-form-group>	
                    <b-form-group class=" mb-0 mt-auto pb-1 ml-2" id="group-radio-student" style="width: 18%;max-width: 180px;">
                        <b-form-radio class="m-auto w-100" v-model="typeStudentGroup" name="CurrentStudent" :value="true" @change="getListGroupClassTeacher()" >{{$t('teacher-student.CurrentStudent')}}</b-form-radio>
                    </b-form-group>
                    <b-form-group class=" mb-0 mt-auto pb-1" id="group-radio-student" style="width: 19%;max-width: 180px;">
                        <b-form-radio class="m-auto w-100" v-model="typeStudentGroup" name="PreviousStudent" :value="false" @change="getListGroupClassTeacher()" >{{$t('teacher-student.PreviousStudent')}}</b-form-radio>
                    </b-form-group>
                </b-form>
            </div>

            <b-table responsive  hover :items="itemsTableGroup"  :busy="isBusy"  :fields="fieldsGroup" :show-empty="true"
                    id="table-group-my-student"  :tbody-transition-props="transProps"  primary-key="date" style="white-space: pre-line;"
                    :empty-text="$t('reusables.empty-text')">
                <template #table-busy>
                    <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong> {{$t('ClassRequest.Loading')}}...</strong>
                    </div>
                </template>

                    <template #cell(schedule)="data">
                        <div class="table-icon" v-if="typeStudentGroup">
                            <span  @click="getListScheduleClass(data.item.groupId,data.item.groupScheduleStudentId)" >
                                 <img src="@/assets/icons/icon-calendar.svg" class="svg">
                            </span>
                        </div>
                        <div class="table-icon" v-else>
                            <span>-</span>
                        </div>
                    </template>
                     <template #cell(classReport)="data">   
                        <div class="table-icon" v-if="data.value>=0">
                            <img src="@/assets/icons/icon-statistical-result.svg"  @click="getClassReport(data.item)" class="svg">
                            <span class="dot" v-if="data.value>0" >{{data.value}}</span> 
                        </div>
                        <div class="table-icon" v-else>
                             <span>-</span>
                            <!-- <span class="material-icons-outlined" @click="getDetail(data.item.id,data.item)">question_answer</span> -->
                        
                        </div>
                    </template>
           
                  
                    <template #cell(chat)="data">
                        <div class="table-icon" v-if="data.value>=0" @click="redirectChat(data.item.groupId)">
                            <img src="@/assets/icons/icon-comments.svg" class="svg">
                             <span class="dot" v-if="data.value>0">{{data.value}}</span>
                        </div>
                        <div class="table-icon" v-else>
                             <span>-</span>
                        </div>
                    </template>

                    <template #cell(student)="data">
                        <div class="container-row-table" v-for="(item, index) in  data.value" :key="`student-${index}`">
                                <span style="cursor:pointer" @click="getCoursesHistoryGroup(item,data.item)" >{{item.name}} </span>   
                        </div>
                    </template>
                   
                    <template #cell(assignments)="data">
                        
                        <div class="container-row-table" v-for="(item, index) in  data.value" :key="`assignments-${index}`">
                             
                              <div class="table-icon" v-if="item.assignment == '-'">
                                <span>-</span>
                            </div>
                             <div class="table-icon" v-else @click="goEvaluationReports(1,data.item,item)">
                                <!-- <span class="material-icons-outlined icon-student" @click="getDetail(item.studentId,data.item)">question_answer</span> -->
                                <img src="@/assets/icons/icon-valid-doc.svg"  class="svg">
                                <span v-if="item.assignment>0" class="dot"  >{{item.assignment}}</span>
                            </div>

                        </div>
                      
                    </template>
                      <template #cell(report)="data">
                          <span></span>
                       <div class="container-row-table" v-for="(item, index) in  data.value" :key="`report-${index}`">
                          
                            <div class="table-icon" v-if="item.report == '-'">
                                <span>-</span>
                            </div>
                             <div class="table-icon" v-else @click="goEvaluationReports(0,data.item,item)">
                                <!-- <span class="material-icons-outlined icon-student" @click="getDetail(item.studentId,data.item)">question_answer</span> -->
                                <img src="@/assets/icons/icon-result-note.svg" class="svg">
                                <span v-if="item.report>0" class="dot" >{{item.report}}</span>
                            </div>
                        </div>
                    </template>
                
            </b-table>
            <div class="overflow-auto content-pagination">
                <b-pagination
                v-model="currentPageGroup"
                :total-rows="totalRowsGroup"
                :per-page="perPageGroup"
               
                aria-controls="table-group-my-student"
                ></b-pagination>
                {{currentPageGroup}}-{{perPageGroup}} / {{totalRowsGroup}}  {{$t('ClassRequest.text.3')}}
            </div>
			</b-tab>
		</b-tabs>

      
        <!--:key="`teacher-modal-schedule`" -->
        <viewCalendarStudent ref="calendarStudent" />
    </div>
</template>
<script>

let cancelToken

import CustomSelect from "@/components/form/select";
import { baseInstanceAxios } from "@/assets/js/axiosBase.js";
import axios from "axios";
import * as Constants from "@/assets/js/appConstants";
import ItemTemplate from "@/views/student/class/ItemTemplate";
import viewCalendarStudent from "@/components/modals/ModalCalendarStudent";
import * as tools from '@/assets/js/tools.js';

export default {
    components: {
      viewCalendarStudent,
      CustomSelect
    },
    data(){
        return{
            items :[],
            item: null,
            itemsGroup : [],
            itemGroup : null,
            itemsIndividual : [],
            itemIndividual : null,
            template: ItemTemplate,
            templateGroup: ItemTemplate,
            templateIndividual: ItemTemplate,
            
            typeStudent:true,
            selectedReport:null,
            typeStudentGroup:true,
            selectedReportGroup:null,

            optionsReport:[],
            flagUpdate: false,
           
            isBusy: false,
            totalRows :0,
            perPage: 10,
            currentPage: 1,

            totalRowsGroup :0,
            perPageGroup: 10,
            currentPageGroup: 1,

            transProps: {
                name: 'flip-list'
            },
            fields: [
                {key: 'student', label: this.$t('teacher-student.table-th.student')},//
                {key: 'level', label: this.$t('teacher-student.table-th.level'),thStyle:"width: 120px;"},//
                {key: 'courses', label: this.$t('teacher-student.table-th.courses'),thStyle:"width: 24%;"},//
                {key: 'schedule', label: this.$t('teacher-student.table-th.schedule')},//
                {key: 'classReport', label:'Class Reports'},//
                {key: 'assignments', label: this.$t('teacher-student.table-th.assignments')},//
                {key: 'report', label: this.$t('teacher-student.table-th.report')},//
                {key: 'chat', label: this.$t('teacher-student.table-th.chat')},//

	     	],
            fieldsGroup: [
                {key: 'group', label: this.$t('teacher-student.table-th.group')},//
                {key: 'level', label: this.$t('teacher-student.table-th.level')},//
                {key: 'courses', label: this.$t('teacher-student.table-th.courses'),thStyle:"width: 24%;"},//
                {key: 'schedule', label: this.$t('teacher-student.table-th.schedule')},//
                {key: 'classReport', label:'Class Reports'},//
                {key: 'chat', label: this.$t('teacher-student.table-th.chat')},//
                {key: 'student', label: this.$t('teacher-student.table-th.student')},//
                {key: 'assignments', label: this.$t('teacher-student.table-th.assignments')},//
                {key: 'report', label: this.$t('teacher-student.table-th.report')},//
    
	     	],
            itemsTableIndividual:[],
            itemsTableGroup:[]

        }
    },
    created(){
        if(this.$route.params.type != null){
            this.TabClassRequest = this.$route.params.type
        }
        if(this.$route.params.typeStudent != null){
            this.typeStudent = this.$route.params.typeStudent
        }
        this.getListComboReport();
        this.getListTabInit();  
    },
    mounted(){
        this.$root.$on('updateViewStudent', (value) => { 
            this.flagUpdate = value;
            if(this.flagUpdate){    
                this.getListSchedulePublicByTeacher();
            }
        }),
        this.$nextTick(function () {
			tools.imgToSvg()
		})
    },
     watch:{
        currentPageGroup: {
			handler: function(newVal, oldVal) {
                if(newVal != null){
                    this.getListGroupClassTeacher();
                }
				
			}
		},
        currentPage: {
			handler: function(newVal, oldVal) {
                if(newVal != null){
                    this.getListClassTeacher();
                }
				
			}
		}
    },
    methods:{
         // Metodo que se le envia historial
        getCoursesHistoryGroup(item,data){
         
            this.$router.push({name : 'teacher-student-courseHistory' , params : {id:parseInt(item.studentId),name:item.name,groupId: data.groupId }})
        },
        // Metodo que se le envia historial
        getCoursesHistory(item,data){
       
            this.$router.push({name : 'teacher-student-courseHistory' , params : {id:item.personStudentId,name:item.student ,groupId: data.groupId  }})
        },

      
        idValueSelectEventOptionsReport(event){
            this.selectedReport = event;
        },
        idValueSelectEventGroupStudent(event){
            this.selectedReportGroup = event;
        },
        goEvaluationReportsSimple(value,item){
            console.log("goEvaluationReportsSimple")
            this.$router.push({name : 'teacher-student-evaluations-reports' , params :
            { 
                id : value , 
                flagHistory : this.typeStudent ? false : true,
                disabledTab : 1 ,//deshabilita evaluacion,
                groupId : item.groupId  , 
                personStudentId : item.personStudentId, 
                nameSubject : item.course, 
                flagTab : false,
                TabClassRequest: this.TabClassRequest,
                typeStudent: this.typeStudent
            } 
            })
        },
        goEvaluationReports(value,item,data){
            console.log("goEvaluationReports")
            this.$router.push({name : 'teacher-student-evaluations-reports' , params : 
            { 
                id : value , 
                flagHistory :this.typeStudentGroup ? false: true,
                disabledTab : 1 ,//deshabilita evaluacion,
                groupId : item.groupId  , 
                personStudentId : parseInt(data.studentId) , 
                flagTab : false,
                TabClassRequest: this.TabClassRequest,
                typeStudent: this.typeStudent
            } 
            })
        },
        getClassReport(data){
            this.$router.push({name : 'teacher-class' ,
                params: {
                    filterGroupId: data.groupId,
                    filterNameStudent : this.TabClassRequest ? data.student : data.group
                }
            }).catch(()=>{})
        },
        getListScheduleClass(groupId,groupScheduleStudentId){
         
            let data = {
                groupId : groupId,
                groupScheduleStudentId: groupScheduleStudentId
            }
           
           this.$refs.calendarStudent.getShowCalendar(data)
        },
        getListComboReport(){
            baseInstanceAxios
            .get(`${this.apiURL}/resources/PersonsStudents/ComboTipoEstadoReporte`)
            .then((response) => {
                this.optionsReport = response.data.list;
            });
        },

        getListGroupClassTeacher(){
      
            this.isBusy = true;
			let data = {
                studentName:  this.itemIndividual ? this.itemIndividual.name : null,
                groupCode :this.itemGroup ? this.itemGroup.name : null,
				tearcherid : this.teacherId,
                typeStudents : this.typeStudentGroup,
                estadoReporte :this.selectedReportGroup,
				Page : this.currentPage,
				Size : this.perPage
    		}
       
			this.itemsTableGroup = []
            baseInstanceAxios
                .get(
				 `${this.apiURL}/resources/PersonsStudents/ListByGroupsNotIndividual`,
				  	{
						params: data
					}
				 )
                .then(response => {
                      //console.log("response.data.list: ",response.data.list)
                      response.data.list.forEach(element => {
                        let data = {
                            id : element.id,
                            groupId: element.groupId,
                            groupScheduleStudentId: element.groupScheduleStudents.id,
                            group:element.group.code,
                            level:element.group.levels.name,
                            courses:element.group.strSubjects_EN.replaceAll('|', '\n'),
                            classReport:element.classrReports,
                            chat:element.chatTotal,
                            student : [],
                            assignments:[],
                            report:[],
                        }
                       
                        let studentsIds =  element.group.studentsIds.split("|")
                        let student = element.group.strStudents.split("|")
                        let assignments =  []
                        let report =  []

                        if(element.strAssignmentsEvaluations != "" || element.strAssignmentsEvaluations == '-'){
                            assignments= element.strAssignmentsEvaluations.split("|")
                        }
                        
                        if(element.strStudentReports != "" || element.strStudentReports == '-'){
                            report= element.strStudentReports.split("|")
                        }
                        for (const index in studentsIds) {
                          
                            data.student.push({
                                studentId :  studentsIds[index],
                                name : student[index]
                            })
                          
                            data.assignments.push({
                                studentId :  studentsIds[index],
                                assignment : assignments[index] == undefined ? '-' : assignments[index]
                            })
                            data.report.push({
                                studentId :  studentsIds[index],
                                report : report[index] == undefined ? '-' : report[index]
                            })
                        }

     

                        this.itemsTableGroup.push(data)
                    });
                
            
                    this.totalRowsGroup=  response.data.rows;
                    this.isBusy = false;
                    this.$nextTick(function () {
                        tools.imgToSvg()
                    })
                });
        },
        getListClassTeacher(){
     
            this.isBusy = true;
			let data = {
                studentName:  this.item ? this.item.name : null,
				tearcherid : this.teacherId,
                typeStudents : this.typeStudent,
                estadoReporte :this.selectedReport,
				Page : this.currentPage,
				Size : this.perPage
    		}
     
			this.itemsTableIndividual = []
            baseInstanceAxios
                .get(
				 `${this.apiURL}/resources/PersonsStudents/ListByGroupsIndividual`,
				  	{
						params: data
					}
				 )
                .then(response => {
                    
                    this.itemsTableIndividual = response.data.list.map(element =>(
                      
                        {
                            id : element.id,
                            groupId: element.groupId,
                            personStudentId : element.personStudent.id,
                            groupScheduleStudentId: element.groupScheduleStudents.id,
                            student:element.personStudent.person.strFullName,
                            photo : element.personStudent.person.photo,
                            level:element.personStudent.level.name,
                            courses:element.personStudent.subjectsStr_EN != '' ?element.personStudent.subjectsStr_EN.replaceAll('|', '\n') : '-',
                            classReport:element.classrReports,
                            assignments:element.strAssignmentsEvaluations == '' || element.strAssignmentsEvaluations == '-' ? '-' : parseInt(element.strAssignmentsEvaluations),
                            report: element.strStudentReports == '' || element.strStudentReports == '-' ? '-' : parseInt(element.strStudentReports),
                            chat:element.chatTotal
                        }
                    ))
                    this.totalRows=  response.data.rows;
                    this.isBusy = false;
                    this.$nextTick(function () {
                        tools.imgToSvg()
                    })
                });
        },

        getLabelGroup(item){
            this.itemGroup = item;
            this.getListGroupClassTeacher();
            return item?.name;
        },
        getLabelIndividual(item){
            this.itemIndividual = item;
            this.getListGroupClassTeacher();
            return item?.name;
        },

        getLabel (item) {
            this.item = item;
            this.getListClassTeacher();
            return item?.name;
        },

        
        updateItemsGroup(text) {
            console.log("updateItemsGroup")
            let params = {
                Id: this.teacherId,
                Filter: text
            }
        
            baseInstanceAxios
                .get(`${this.apiURL}/resources/PersonsStudents/AutoCompleteGroupNotIndividual`, {params})
                .then((response) => {
                 
                    if(response.data && response.data.list){
                        this.itemsGroup = response.data.list.map(x => ({
                            id: x.id,
                            name: x.descripcion
                        }));
                    }

            
                });
        },

        updateItemsIndividual(text) {
            console.log("updateItemsIndividual")
            //Check if there are any previous pending requests
            if (typeof cancelToken != typeof undefined) {
                console.log("Operation canceled due to new request.")
                cancelToken.cancel("Operation canceled due to new request.")
            }

            //Save the cancel token for the current request
            cancelToken = axios.CancelToken.source()

            let params = {
                            Id: this.teacherId,
                            Filter: text,
                            TypeGroups : !this.TabClassRequest,
                            currentStudents: this.typeStudentGroup
                        }
            
            baseInstanceAxios
                .get(`${this.apiURL}/resources/PersonsStudents/AutoCompleteGroupIndividual`, 
                    {
                        params: params,
                        cancelToken: cancelToken.token
                    }
                )
                .then((response) => {
                  
                    if(response.data && response.data.list){
                        this.itemsIndividual = response.data.list.map(x => ({
                            id: x.id,
                            name: x.descripcion
                        }));
                    }

            
                });
        },

        updateItems (text) {
             
            //Check if there are any previous pending requests
            if (typeof cancelToken != typeof undefined) {
                console.log("Operation canceled due to new request.")
                cancelToken.cancel("Operation canceled due to new request.")
            }

            //Save the cancel token for the current request
            cancelToken = axios.CancelToken.source()
            

            let params = {
                Id: this.teacherId,
                Filter: text,
                TypeGroups : !this.TabClassRequest,
                currentStudents: this.typeStudent
            }
             
            baseInstanceAxios
                .get(`${this.apiURL}/resources/PersonsStudents/AutoCompleteGroupIndividual`
                    ,{ cancelToken: cancelToken.token, params:  params}
                )
                .then((response) => {
            
                    if(response.data && response.data.list){
                        this.items = response.data.list.map(x => ({
                            id: x.id,
                            name: x.descripcion
                        }));
                    }

            
                });
        },
        getListTabInit(){
      
           
             if(this.TabClassRequest){
                //Individual    
                this.getListClassTeacher();
             }else{
                 //grupal
                 this.getListGroupClassTeacher();
    
             }
        },
        changeTab(indexTab){
	
			this.TabClassRequest =  true;
			if(indexTab!=0){
				this.TabClassRequest = false;
			}

            this.getListTabInit();

		},
        updateListStrudent(){
  
            this.getListSchedulePublicByTeacher();
            this.flagUpdate = false;
        },
     
        getListSchedulePublicByTeacher() {
      
			this.isBusy = true;
			let data = {
				PersonTeacherId : this.teacherId,
				Page : this.currentPage,
				Size : this.perPage
    		}
			this.itemsTable = []
            baseInstanceAxios
                .get(
				 `${this.apiURL}/resources/GroupScheduleCounterProposal/ListEditionSchedule`,
				  	{
						params: data
					}
				 )
                .then(response => {
             
                    if(response.data != null && response.data.list != null){
                     
                        response.data.list.forEach(element => {
                       
                            let json = {
                                id : element.id,
                                requestDate :  element.requestDateString, 
                                beginningDate :  element.beginningDate, 
                                strFullName : element.flagGroup? element.codeGroup.replaceAll(',[br]','\n') :element.personsStudents.person.strFullName ,
                            }
                           
                            this.itemsTable.push(json)
                            
                        });
                    
                        this.totalRows=  response.data.rows;
                       
                        this.isBusy = false;

        
                    }
                });
							
        },
        redirectChat(idGroup){
            if((this.TabClassRequest && this.typeStudent) || (!this.TabClassRequest && this.typeStudentGroup)){
                this.$router.push({name : 'chat' , params: {filterGroupId : idGroup}});
            }
        }
    },
    computed: {
 
        TabClassRequest: {
			get(){
				return this.$store.state.classRequestTab
			},
			set(value) {
				this.$store.dispatch('updateClassRequestTab',value);
      		}
		},
        teacherId: {
            get() {
                return this.$store.state.user.personTeacherId;
            }
        },
        User: {
            get() {
                return this.$store.state.user;
            },
        }
		
    },
}
</script>